// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"381":"vault","594":"about"}[chunkId] || chunkId) + "." + {"381":"4db999ef","592":"52c5ce66","594":"eb2e7bf3"}[chunkId] + ".js";
};